import type { SVGProps } from 'react';

/** The handful of glyphs the kit draws itself: 24-unit box, 1.8 stroke, round caps (brand geometry). Decorative. */
function Glyph({ d, ...rest }: SVGProps<SVGSVGElement> & { d: string }) {
  return (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...rest}>
      <path d={d} />
    </svg>
  );
}

export const IconSearch = (p: SVGProps<SVGSVGElement>) => <Glyph {...p} d="M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm9 2-4.35-4.35" />;
export const IconClose = (p: SVGProps<SVGSVGElement>) => <Glyph {...p} d="M6 6l12 12M18 6 6 18" />;
export const IconChevron = (p: SVGProps<SVGSVGElement>) => <Glyph {...p} d="m9 6 6 6-6 6" />;
export const IconSort = (p: SVGProps<SVGSVGElement>) => <Glyph {...p} d="m8 10 4-4 4 4M8 14l4 4 4-4" />;
export const IconArrowUp = (p: SVGProps<SVGSVGElement>) => <Glyph {...p} d="M12 19V5m-6 6 6-6 6 6" />;
export const IconArrowDown = (p: SVGProps<SVGSVGElement>) => <Glyph {...p} d="M12 5v14m6-6-6 6-6-6" />;
export const IconInbox = (p: SVGProps<SVGSVGElement>) => <Glyph {...p} d="M4 13h4l2 3h4l2-3h4M5.5 5h13L21 13v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5l2.5-8Z" />;
export const IconAlert = (p: SVGProps<SVGSVGElement>) => <Glyph {...p} d="M12 8v5m0 3.5v.01M10.3 3.9 2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />;
